import forge from 'apis/forge';
import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { updateFigmaConnected } from 'redux/db/actions';
import { selectFigmaConnected } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { openFigmaAuthPopup } from 'utils';

interface Props {
	label: string;
}

const ReconnectFigmaAction = ({ label }: Props) => {
	const dispatch = useDispatch();
	const figmaConnected = useSelector((r: RootReducer) => selectFigmaConnected(r.db));

	const onClick = async () => {
		// Force a clean slate before reauthorizing — if the LLM suggested this, the stored
		// token is known-broken and we want the popup to produce a fresh one even if Figma
		// would otherwise short-circuit the OAuth grant.
		if (figmaConnected) {
			await forge.disconnectFigma();
		}
		const ok = await openFigmaAuthPopup();
		if (ok) dispatch(updateFigmaConnected(true));
	};

	return <ActionButton icon={IconType.EXTERNAL} label={label} onClick={onClick} />;
};

export default ReconnectFigmaAction;
